import { render, staticRenderFns } from "./appointmentTimeAlertView.vue?vue&type=template&id=83b5f4bc&scoped=true"
import script from "./appointmentTimeAlertView.vue?vue&type=script&lang=js"
export * from "./appointmentTimeAlertView.vue?vue&type=script&lang=js"
import style0 from "./appointmentTimeAlertView.vue?vue&type=style&index=0&id=83b5f4bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b5f4bc",
  null
  
)

export default component.exports